import React, {  } from 'react';

import { numberFormatOptions } from '../types';
import { IntlFunction } from './Intl.Function';
import { NumberFormatInput, NumberFormatRuleSet } from './Intl.NumberFormat';

export const IntlNumberFormatFormat = () => (
	<IntlFunction
		input={NumberFormatInput}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/format"
		header="Intl.NumberFormat.prototype.format"
		description="Formats a number according to the locale and formatting options of this [Intl.NumberFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat) object."
		options={numberFormatOptions}
		ruleSet={NumberFormatRuleSet}
		template="new Intl.NumberFormat(##locale##, ##options##).format(##input:number##)" />
)